import React, { useState } from "react";
import ButtonTheme from "../components/ButtonTheme";
import {
  Link,
  Box,
  Container,
  Flex,
  Grid,
  Heading,
  Image,
  Select,
  Text,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  List,
  ListItem,
  ListIcon,
  OrderedList,
  UnorderedList,
} from "@chakra-ui/react";
import Tentative from "../img/tentative.png";
import Vcard from "../assets/vcard-welltower-service-center.vcf";
import { useHistory } from "react-router-dom";
import TenantReferalFrom from "../components/old-site/TenantReferralForm2";
import {Helmet} from "react-helmet";
import {absoluteUrl} from "../components/Utils";

const TenantPage = ({showReferralForm}) => {
  const [open, setIsOpen] = useState(showReferralForm);
  const handleButtonClickTenantPortal = () => {
    //window.location.href = "http://tenant.welltower.com/";
  };
  const handleButtonClickVCard = () => {};
  const handleButtonClickReferal = () => {
    setIsOpen(true);
  };
  const history = useHistory();
  // const handleButtonClick = (location) => {
  //     history.push(location);
  //   };

  const handleButtonClick = () => {
    window.location.href = "/search?address=";
  };

  return (
      <>
        <Helmet>
        {/* This should get title and description from the Helmet in App.js */}
        <link rel="canonical" href={ absoluteUrl( showReferralForm ? "/refer" : "/current-tenants")} />
      </Helmet>
    <Box>
      <Box
        pt={"78px"}
        bgGradient="radial-gradient(51.2% 83.31% at 98.33% 0%, rgba(43, 101, 145, 0.51) 0%, rgba(50, 153, 183, 0) 100%)"
      >
        <Container maxW={"95%"}>
          <Box textAlign={"center"} mt={12} pt={"75px"} paddingBottom={10}>
            <Heading
              mb={5}
              fontSize={{ xl: "24px", base: "" }}
              color={"Teal"}
              fontWeight={500}
            >
              Welltower Medical Office
            </Heading>
            <Heading
              mb={12}
              fontSize={{ xl: "7xl", base: "4xl" }}
              color={"DarkTeal"}
              fontFamily={"Utopia Std"}
              letterSpacing={-3}
            >
              Current Tenants
            </Heading>
          </Box>
        </Container>
        <Box
          mt={24}
          h={"472px"}
          bgImage={Tentative}
          bgSize={"cover"}
          bgPos={"center center"}
        />
        {/* <Image src={Tentative} width="100%"></Image> */}
      </Box>
      <Box my={10}>
        <Container maxW={["100%", "70%"]}>
          <Card mb={10} boxShadow="0px 0px 20px 0px #0000001A">
            <CardBody pt={50} px={50} pb={30}>
              <Grid
                templateColumns={["1fr", "repeat(2, 1fr)", "repeat(2, 1fr)"]}
                gap={6}
              >
                <Box w="100%">
                  <Heading
                    mb={2}
                    fontSize={{ xl: "5xl", base: "" }}
                    color={"Teal"}
                    fontWeight={500}
                    fontStyle={"italic"}
                  >
                    Tenant Portal
                  </Heading>
                  <Text
                    fontSize={{ xl: "14px", base: "14px" }}
                    color={"DarkBlue"}
                    fontStyle={"italic"}
                  >
                    If you need assistance with the Tenant Portal, please
                    contact your Property Manager or the Welltower Service
                    Center.
                  </Text>
                </Box>
                <Box w="100%">
                  <UnorderedList>
                    <ListItem fontSize={"1rem"} color={"DarkBlue"}>
                      24/7 self-service account management
                    </ListItem>
                    <ListItem fontSize={"1rem"} color={"DarkBlue"}>
                      Easily check balances & make payments
                    </ListItem>
                    <ListItem fontSize={"1rem"} color={"DarkBlue"}>
                      Schedule recurring auto-payments for rent & other charges
                    </ListItem>
                    <ListItem fontSize={"1rem"} color={"DarkBlue"}>
                      More visibility, less late/finance fees
                    </ListItem>
                    <ListItem fontSize={"1rem"} color={"DarkBlue"}>
                      Submit maintenance requests
                    </ListItem>
                    <ListItem fontSize={"1rem"} color={"DarkBlue"}>
                      View lease information & documents
                    </ListItem>
                    <ListItem fontSize={"1rem"} color={"DarkBlue"}>
                      View property contacts, announcements & events
                    </ListItem>
                  </UnorderedList>
                  <Box align="right" pt={10}>
                    <a href="http://tenant.welltower.com/" target="_blank" id="btn_tenant_visit_tenant_portal">
                      <ButtonTheme
                        btnText={"Visit Tenant Portal"}
                        handleButtonClick={handleButtonClickTenantPortal}
                      />
                    </a>
                  </Box>
                </Box>
              </Grid>
            </CardBody>
          </Card>
          <Card mb={10} boxShadow="0px 0px 20px 0px #0000001A">
            <CardBody pt={50} px={50} pb={30}>
              <Grid
                templateColumns={["1fr", "repeat(2, 1fr)", "repeat(2, 1fr)"]}
                gap={6}
              >
                <Box w="100%">
                  <Heading
                    mb={0}
                    fontSize={{ xl: "5xl", base: "" }}
                    color={"Teal"}
                    fontWeight={500}
                    fontStyle={"italic"}
                  >
                    Welltower
                  </Heading>
                  <Heading
                    mb={2}
                    fontSize={{ xl: "5xl", base: "" }}
                    color={"Teal"}
                    fontWeight={500}
                    fontStyle={"italic"}
                  >
                    Service Center
                  </Heading>
                </Box>
                <Box w="100%">
                  <Text pb={5}>
                    Connect with a live representative 24/7 by calling
                    <Link px={1} color={"Teal"} href="telto:1-833-275-9355" id="btn_tenant_service_center_phone">
                      1-833-ASK-WELL (1-833-275-9355).
                    </Link>
                    For non-urgent matters, you can reach us via email at
                    <Link
                      px={1}
                      color={"Teal"}
                      href="mailto:AskWell@welltower.com"
                      id="btn_tenant_service_center_email"
                    >
                      AskWell@welltower.com.
                    </Link>{" "}
                    Please note that our email is monitored from 7 AM to 6 PM
                    Central Time, Monday through Friday, excluding holidays.
                  </Text>
                  <Text pb={5}>
                    For pressing property management concerns requiring
                    immediate attention, please call{" "}
                    <Link px={1} color={"Teal"} href="telto:1-833-275-9355" id="btn_tenant_service_center_phone2">
                      1-833-ASK-WELL
                    </Link>
                    .
                  </Text>
                  <Text pb={5}>
                    This service is dedicated to building or property management
                    issues. In the case of a life-threatening emergency, please
                    call 911.
                  </Text>
                  <Text>
                    For the most efficient method of submitting routine
                    maintenance requests, please use the online Tenant Portal.
                  </Text>
                  <Box align="right" pt={10}>
                    <a href={Vcard} target="_blank" rel="noreferrer" id="btn_tenant_service_center_download_vcard">
                      <ButtonTheme
                        btnText={"Download vCard"}
                        handleButtonClick={handleButtonClickVCard}
                      />
                    </a>
                  </Box>
                </Box>
              </Grid>
            </CardBody>
          </Card>
          <Card mb={10} boxShadow="0px 0px 20px 0px #0000001A">
            <CardBody pt={50} px={50} pb={30}>
              <Grid
                templateColumns={["1fr", "repeat(2, 1fr)", "repeat(2, 1fr)"]}
                gap={6}
              >
                <Box w="100%">
                  <Heading
                    fontSize={{ xl: "5xl", base: "" }}
                    color={"Teal"}
                    fontWeight={500}
                    fontStyle={"italic"}
                  >
                    Tenant
                  </Heading>
                  <Heading
                    mb={2}
                    fontSize={{ xl: "5xl", base: "" }}
                    color={"Teal"}
                    fontWeight={500}
                    fontStyle={"italic"}
                  >
                    Referral Form
                  </Heading>
                </Box>
                <Box w="100%">
                  <Heading
                    mb={5}
                    fontSize={{ xl: "24px", base: "" }}
                    color={"Teal"}
                    fontWeight={400}
                  >
                    Join us in shaping your community
                  </Heading>
                  <Text my={5}>
                    Your referrals play a vital role in developing a synergistic
                    blend of specialties, ensuring convenient access to care for
                    your patients.
                  </Text>
                  <Text>
                    Working together, we can create a vibrant building
                    community.
                  </Text>
                  <Box className="modal-custom-btn" align="right" pt={10}>
                    <TenantReferalFrom startOpen={open} />
                  </Box>
                </Box>
              </Grid>
            </CardBody>
          </Card>
          <Card mb={10} boxShadow="0px 0px 20px 0px #0000001A">
            <CardBody pt={50} px={50} pb={30}>
              <Grid
                templateColumns={["1fr", "repeat(2, 1fr)", "repeat(2, 1fr)"]}
                gap={6}
              >
                <Box w="100%">
                  <Heading
                    fontSize={{ xl: "5xl", base: "" }}
                    color={"Teal"}
                    fontWeight={500}
                    fontStyle={"italic"}
                  >
                    Need More
                  </Heading>
                  <Heading
                    mb={2}
                    fontSize={{ xl: "5xl", base: "" }}
                    color={"Teal"}
                    fontWeight={500}
                    fontStyle={"italic"}
                  >
                    Space?
                  </Heading>
                </Box>
                <Box w="100%">
                  <Text my={5}>
                    Whether your current location is feeling crowded or you are
                    considering expansion through additional sites, let's talk
                    about your options. Click below to explore our current
                    available spaces.
                  </Text>
                  <Box align="right" pt={10}>
                    <ButtonTheme
                      btnText={"Search for space"}
                      handleButtonClick={handleButtonClick}
                      chakraProps={{
                        id: "btn_tenant_search_for_space"
                      }}
                      />
                  </Box>
                </Box>
              </Grid>
            </CardBody>
          </Card>
        </Container>
      </Box>
    </Box>
      </>
  );
};
export default TenantPage;
